import { connect } from 'react-redux'
import TextComponent from "../components/TextComponent";
import { changeText, updateTextStatus, setTextOptions, resizeUpdate, updateGroupText, deleteItem, syncText, setSlideJump, setSelectedScene, setScenePosition, } from "../actions/index"


const mapStateToProps = (state, ownProps) => ({
  workspaceParent : (ownProps.isGrouped || ownProps.isTextOverlay)?() => {
    return state.project.getIn(["scenes", state.localStore.get("selectedScene"), "workspaceItems", ownProps.data_id]);
  }:null,
  parentItem      : ownProps.isGrouped ? state.project.getIn(["scenes", state.localStore.get("selectedScene"), "workspaceItems", ownProps.data_id]) : null,
  selectedScene   : state.localStore.get("selectedScene"),
  workspaceWidth  : state.project.get("width"),
  selectedItems   : state.localStore.get("selectedItems"),
  zoomFactor      : state.localStore.get("zoomFactor"),
  isPlay          : state.localStore.get("isPlay"),
  isPlayAll       : state.localStore.get("isPlayAll"),
  textStatus      : state.localStore.get("textStatus"),
  transformStatus : state.localStore.get("transformStatus"),
  textUpdated     : state.localStore.get("textUpdated"),
  workspaceItems  : state.project.getIn(["scenes", state.localStore.get("selectedScene"), "workspaceItems"]),
  animakerType    : state.localStore.get("animakerType"),
  fontStatus      : state.localStore.getIn(["loadedFonts", "fonts"]).find(x => x.get("load") === ownProps.text.getIn(["textData", "formats", "containerStyle", "fontFamily"])),
  fontTrack       : state.localStore.getIn(["loadedFonts", "fontTracking", !ownProps.isGrouped ? ownProps.data_id : ownProps.itemId]),
  loadedFonts     : state.localStore.get("loadedFonts"),
  audioPlayHead   : state.localStore.get("audioPlayHead"),
  undoResize      : state.localStore.get("undoResize"),
  textOffset      : ownProps.text.getIn(["textData", "formats", "containerStyle", "margin"]) === "0px" ? state.localStore.get("textOffset") : 30,
  isHyperLinkTextAdded : state.localStore.get('isHyperLinkTextAdded'),
  lastEditText    : state.localStore.get("lastEditText"),
  project         : state.project,
  scenes          : state.project.getIn(["scenes"]),
  isPreview       : state.localStore.get('isPreview'),
  t1                   : state.localStore.get('t1'),
  currentSceneNumber   : state.localStore.get('currentSceneNumber'),
  isFullScreen        : state.localStore.get("isFullScreen"),
  childrenSelection: state.localStore.get("childrenSelection"),



})

const mapDispatchToProps = (dispatch, ownProps) => ({
  changeText:(data, socket) => {
    dispatch(changeText(data, socket))
  },
  deleteItem: (data, socket) => { dispatch(deleteItem(data, socket)) },
  resizeUpdate:(data) => {
    dispatch(resizeUpdate(data))
  },
  updateTextStatus:(data) => {
    dispatch(updateTextStatus(data))
  },
  setTextOptions:(data) => {
    dispatch(setTextOptions(data))
  },
  updateGroupText:(data, socket) => {
    dispatch(updateGroupText(data, socket))
  },
  updateObject:(data, socket) => {
    dispatch({type : "UPDATE_OBJECT", data : data, socket : socket})
  },
  syncText: (data, socket) => {
    dispatch(syncText(data, socket))
  },
  writeText:(data, socket) => {
    dispatch({type : "WRITE_TEXT", data : data, socket : socket})
  },
  setSlideJump: (data) => {
      dispatch(setSlideJump(data))
    },
  setSelectedScene: (data, time, selectedScenes, socket) =>
  {
      dispatch(setSelectedScene(data, time, selectedScenes, socket))
  },
  setScenePosition : (data  , currentSceneNumber , currentSceneStartTime , currentSceneDuration) =>{
    dispatch(setScenePosition(data  , currentSceneNumber , currentSceneStartTime , currentSceneDuration))},
  fontLoaded: (data) => { dispatch({ type: "FONT_LOADED", data: data }) },
})

const Text = connect(
  mapStateToProps,
  mapDispatchToProps
)(TextComponent)

export default Text



// WEBPACK FOOTER //
// ./src/containers/Text.js